import axios from "axios";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashboardLayouts from "../Layout/DashboardLayouts";

import { trimStart } from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../../Components/Global/Loader";

import Modal from "react-bootstrap/Modal";
import { FaEye, FaPen, FaSearch } from "react-icons/fa";

import { InputTypeDate, InputTypeSelect, InputTypeText, InputTypeTextarea } from "../../hooks/formsHandler/FormInputs";
import useProfileForm from "../../hooks/formsHandler/useProfileForm";
import useAuthentication from "../../hooks/useAuthentication";
import useAxiosFetch from "../../hooks/useAxiosFetch";
import useToastify from "../../hooks/useToastify";
import DummyImg from "../../Public/Images/568165.png";
import BackToDashboardBtn from "./BackToDashboardBtn";



// all Months store 
const mS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];


const typeOfWorkerList=[
  {
     id: "Plumber",
     name: "Plumber",
   },
   {
     id: "Electrician",
     name: "Electrician",
   },
   {
     id: "Janitor",
     name: "Janitor",
   },
   {
     id: "Cleaner",
     name: "Cleaner",
   },
   {
     id: "Lawn Mower",
     name: "Lawn Mower",
   },
   {
     id: "General",
     name: "General",
   },


  ]

function AddProfileGobal({ allowedRoles }) {

  // function get allow the user this page 
  const { allowLoading } = useAuthentication(allowedRoles);


  // initialize data default
  const { first_name,
    middle_name,
    last_name,
    username,
    email,
    phone_number,
    address,
    apartment,
    city,
    province,
    country,
    postal_code,
    profile_image,
    status,
    AssignsData,
    worker_roles,
    nsf,
    hydroInvoices ,
    internet,
    locker,
    parking,
    advance_rent,
    key_deposit,
    laundry_deposit,
    building_id,
    unit_id,
    taxInfo,
    unit_type,
    monthly_rent,
    lease_start_date,
    lease_end_date,
   
    managerBuildingAssigns,
    buildinglist,
    unitlist,
    unitdetails,
    searchKeywords,
    errorMessage,
    loading,
    makeUrl ,
    searchBuilding,
    countryList, stateList ,
    designation,
    show, profileState,dispatch,handleShow,handleClose,profileId,validation,paymentOption,payment_mode}=useProfileForm();





  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();



    // show toast hook 
  const { notify } = useToastify();;




// show modal for payment receipt show 
  
  const [modalPreviewData, setModalPreviewData] = useState("");



 







  const location = useLocation();
  const pathname = location.pathname;



  



// submit data to  craete user 

  const Submitpartner = (e, skipnow) => {
    e.preventDefault();
    dispatch({type:"set_error",payload:{}})


   

    

    if (
      makeUrl.apiUrl == "manager" &&
      !skipnow &&
      !managerBuildingAssigns?.length > 0
    ) {
    dispatch({type:"set_error",payload:{error: "please choose atleast one building"}})

      // setErrorMessage({ error: "please choose atleast one building" });
      return;
    } else {
      if (makeUrl.apiUrl == "manager") {
        apiCallFunc(e);
      } else {
        const Valid = validation();

     

        if (Object.keys(Valid)?.length == 0) {
          apiCallFunc(e);
        } else {
          // setErrorMessage(Valid);
    dispatch({type:"set_error",payload:Valid})

        }
      }
    }
  };

  // final api Call 

  const apiCallFunc = (e) => {
    e.preventDefault();

    // setLoading(true);
dispatch({type:"set_loading",payload:true})

    const sendTodDb ={
      ...profileState ,
      unit_part: unitdetails?.unit_part,
      apartment_size: unitdetails?.apartment_size,
          unit_type: unitdetails?.unit_type,
   
          AssignsData: managerBuildingAssigns
    }
    const apiCall = profileId
      ? `/${makeUrl.apiUrl}/update/${profileId}`
      : `/${makeUrl.apiUrl}/create`;


      const navigatesUrlsss = makeUrl.apiUrl == "request"
      ? `/addtask`
      : (designation == "Owner" || designation == "Partner") ? `/${makeUrl.apiUrl}list` : `/${designation.toLowerCase()}/${makeUrl.apiUrl}list`;

    if (profile_image?.file) {
      const formdata = new FormData();
      formdata.append("image", profile_image?.file);
      


      axios
        .post("/global/fileupload", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          axiosFetch({
            axiosInstance: axios,
            method: "post",
            url: apiCall,
            navigatesUrl: navigatesUrlsss,
            requestConfig: {
              ...sendTodDb,
              profile_image: res?.data?.links[0],
             
            },
          }).then((res) => {
            dispatch({type:"set_loading",payload:false})
            if (res?.data?.errMsg) {

              handleClose();
              // setErrorMessage({ err: res?.data?.errMsg });
    dispatch({type:"set_error",payload:{ err: res?.data?.errMsg }})

            }
          });

        }).catch(err => {

          dispatch({type:"set_loading",payload:false})
          if(err?.response){

            notify(err?.response?.data?.message, "error");
          }else{
            notify(`The file you are trying to upload is too large`, "error");
          }
        })
    } else {
      axiosFetch({
        axiosInstance: axios,
        method: "post",
        url: apiCall,
        navigatesUrl: navigatesUrlsss,
        requestConfig: {...sendTodDb,profile_image:profile_image.url },
      }).then((res) => {
        dispatch({type:"set_loading",payload:false})
        if (res?.data?.errMsg) {

          handleClose();
          // setErrorMessage({ err: res?.data?.errMsg });
    dispatch({type:"set_error",payload:{ err: res?.data?.errMsg }})

        }
      }).catch(()=>{
        dispatch({type:"set_loading",payload:false})
      })
    }
  };




 


// show modal of building list (manager create) 

  const showModalbuildingList = (e) => {
    e.preventDefault();

    const Valid = validation();
  
    dispatch({type:"set_error",payload:Valid})
    if (Object?.keys(Valid)?.length == 0){
      dispatch({type:"modal_show",payload:{e}})
    }
    
 
  };

 



// all input box js data 
  const profileInputs = [
    {
    
      name: "first_name",
      type: "text",
      placeholder: "First Name",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "First Name",
     
      required: true,
      isShow: true,
      colSize:6
    },
    {
    
      name: "middle_name",
      type: "text",
      placeholder: "Middle Name",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "Middle Name",
     
      // required: true,
      isShow: true,
      colSize:6
    },
    {
    
      name: "last_name",
      type: "text",
      placeholder: "Last Name",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "Last Name",
     
      // required: true,
      isShow: true,
      colSize:6
    },
    {
    
      name: "username",
      type: "text",
      placeholder: "Username",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "Username",
     
      required: true,
      isShow: true,
      colSize:6
    },
    {
    
      name: "email",
      type: "email",
      placeholder: "Email Id",
      errorMessage:
        "Email Id should be 3-16 characters and shouldn't include any special character!",
      label: "Email Id",
     
      required: true,
      isShow: true,
      colSize:6
    },
  
    {
    
      name: "phone_number",
      type: "text",
      placeholder: "Phone Number",
      errorMessage:
        "Phone Number should be 3-16 characters and shouldn't include any special character!",
      label: "Phone Number",
     
      required: true,
      isShow: true,
      colSize:6
    },
  
  
    {
    
      name: "worker_roles",
      type: "selectbox",
      placeholder: "Worker Role",
      errorMessage:
        "Worker Role should be 3-16 characters and shouldn't include any special character!",
      label: "Worker Role",
     
      required: true,
      isShow: pathname.includes("worker") ,
      colSize:6
    },
  
    {
    
      name: "address",
      type: "text",
      placeholder: " Street Address",
      errorMessage:
        " Street Address should be 3-16 characters and shouldn't include any special character!",
      label: " Street Address",
     
      required: true,
      isShow: true,
      colSize:12
    },
    {
    
      name: "apartment",
      type: "text",
      placeholder: "Apartment, Suite",
      errorMessage:
        "Apartment, Suite should be 3-16 characters and shouldn't include any special character!",
      label: "Apartment, Suite",
     
      required: false,
      isShow: true,
      colSize:12
    },
    {
    
      name: "country",
      type: "selectbox",
      placeholder: "Country",
      label: "Country",
      required: true,
      isShow: true,
      colSize:6

    },
    {
    
      name: "province",
      type: "selectbox",
      placeholder: "Province",
      label: "Province",
      required: true,
      isShow: true,
      colSize:6

    },
    {
    
      name: "city",
      type: "text",
      placeholder: "City",
      errorMessage: "It should be a valid email address!",
      label: "City",
      required: true,
      isShow: true,
      colSize:6

    },
    {
    
      name: "postal_code",
      type: "text",
      placeholder: "Postal Code",
      errorMessage: "It should be a valid email address!",
      label: "Postal Code",
      required: true,
      isShow: true,
      colSize:6

    },
    {
    
      name: "building_id",
      type: "selectbox",
      placeholder: "Building Name",
      errorMessage: "It should be a valid email address!",
      label: "Building Name",
      required: true,
      isShow: makeUrl.apiUrl == "tenant" ? true : false,
      colSize:6

    },
    {
    
      name: "unit_id",
      type: "selectbox",
      placeholder: "Unit Name ",
      errorMessage: "It should be a valid email address!",
      label: "Unit Name ",
      required: true,
      isShow: makeUrl.apiUrl == "tenant" ? true : false,

      colSize:6

    },
    {
    
      name: "apartment_size",
      type: "text",
      placeholder: "Apartment Size",
      errorMessage: "It should be a valid email address!",
      label: "Apartment Size",
      required: true,
      isShow: (makeUrl.apiUrl == "tenant" && unit_id && unitlist?.length!==0 )? true : false,
      isReadOnly:true,

      colSize:6

    },
    {
    
      name: "unit_part",
      type: "text",
      placeholder: "Unit Size",
      errorMessage: "It should be a valid email address!",
      label: "Unit Size",
      required: true,
      isShow: (makeUrl.apiUrl == "tenant" && unit_id && unitlist?.length!==0 )? true : false,
      isReadOnly:true,
value:unitdetails?.unit_part,
      colSize:6

    },


  
     

            ...Object?.keys(taxInfo)?.map((taxx, ind) => (
             
             
           

            {
    
              name: taxx,
              type: "text",
              placeholder: taxx,
              errorMessage: "It should be a valid email address!",
              label: taxx,
              required: true,
              isShow: unitdetails?.unit_type !== "Residential" &&   Object?.keys(taxInfo)?.length > 0 && unit_id && unitlist?.length!==0 ,
        isReadOnly:true,
              colSize:2
        
            }



          
      
    )),



    {
    
      name: "monthly_rent",
      type: "text",
      placeholder: "Monthly Rent",
      errorMessage: "It should be a valid email address!",
      label: "Monthly Rent",
      required: true,
      isShow: makeUrl.apiUrl == "tenant" ? true : false,

      colSize:6

    },
    {
    
      name: "lease_start_date",
      type: "date",
      placeholder: "Lease Start Date",
      errorMessage: "It should be a valid email address!",
      label: "Lease Start Date",
      required: true,
      isShow: makeUrl.apiUrl == "tenant" ? true : false,

      colSize:6

    },
    {
    
      name: "lease_end_date",
      type: "date",
      placeholder: "Lease End Date",
      errorMessage: "It should be a valid email address!",
      label: "Lease End Date",
      required: true,
      isShow: makeUrl.apiUrl == "tenant" ? true : false,

      colSize:6

    },
  
   

  ];




  return (
    <>
      <DashboardLayouts>
        {(loading || allowLoading) && <Loader />}

        <div className="building-details w-100">
          {/* --- Section Heading ---- */}
          <div className="breadcrumb row justify-content-between align-items-center">
           <BackToDashboardBtn />

            <div className="col-auto btn-responsive">
              <Link


                to={
                  makeUrl.apiUrl == "request"
                    ? `/addtask`
                    : (designation == "Owner" || designation == "Partner") ? `/${makeUrl.apiUrl}list` : `/${designation.toLowerCase()}/${makeUrl.apiUrl}list`
                }

                className="btn btn-outline-primary"
              >
                Back To Building {makeUrl.apiUrl} List
              </Link>
            </div>
          </div>
          {/* ----- Body Content ---- */}
          <div className="list-data">
            <h1 className="heading-text mb-4">
              {profileId
                ? `Edit Building ${makeUrl.apiUrl.charAt(0).toUpperCase() +
                makeUrl.apiUrl.slice(1)
                }`
                : `Add Building ${makeUrl.apiUrl.charAt(0).toUpperCase() +
                makeUrl.apiUrl.slice(1)
                }`}
            </h1>
          </div>
        </div>

        <div className="add-request-form w-100">
          <form action="" className="dash-form add-form add-building-area">
            <div className="row">
              <div className="col-xl-8">
                <div className="row gy-1 gy-md-4">
                  
                  {/* <div className="col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        First Name<span className="must-field">*</span>
                      </label>
                      <input
                        onChange={(e) =>{
                          dispatch({type:"input",payload:e.target})
                          }}
                        type="text"
                        value={trimStart(first_name)}
                        name="first_name"
                        id="first_name"
                        className={`form-control form-g1`}
                        placeholder={`First Name`}
                      />
                      {errorMessage?.first_name ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.first_name}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Middle Name
                      </label>
                      <input
                   onChange={(e) =>{
                    dispatch({type:"input",payload:e.target})
                    }}
                        type="text"
                        value={trimStart(middle_name)}
                        name="middle_name"
                        id="middle_name"
                        className={`form-control form-g1`}
                        placeholder={`Middle Name`}
                      />

                      {errorMessage?.middle_name ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.middle_name}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Last Name
                      </label>
                      <input
                        onChange={(e) =>{
                          dispatch({type:"input",payload:e.target})
                          }}
                        type="text"
                        value={trimStart(last_name)}
                        name="last_name"
                        id="last_name"
                        className={`form-control form-g1`}
                        placeholder={`Last Name`}
                      />
                      {errorMessage?.last_name ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.last_name}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Username<span className="must-field">*</span>
                      </label>
                      <input
                      onChange={(e) =>{
                        dispatch({type:"input",payload:e.target})
                        }}
                        type="text"
                        // readOnly={username ? true : false}
                        value={trimStart(username)}
                        name="username"
                        readOnly={profileId ? true : false}
                        id="username"
                        className={`form-control form-g1`}
                        placeholder={`Username`}
                      />
                      {errorMessage?.username ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.username}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Email Id<span className="must-field">*</span>
                      </label>
                      <input
                     onChange={(e) =>{
                      dispatch({type:"input",payload:e.target})
                      }}
                        type="text"
                        value={trimStart(email)}
                        name="email"
                        className={`form-control form-g1`}
                        placeholder={`Email`}
                      />
                      {errorMessage?.email ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.email}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Phone Number
                        <span className="must-field">*</span>
                      </label>
                      <input
                       onChange={(e) =>{
                        dispatch({type:"input",payload:e.target})
                        }}
                        type="text"
                        value={trimStart(phone_number)}
                        name="phone_number"
                        className={`form-control form-g1`}
                        placeholder={`Phone Number`}
                      />
                      {errorMessage?.phone_number ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.phone_number}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {pathname.includes("worker") &&
                  
                  (
                    <div className="col-xl-6 col-md-6 mb-2">
                      <div className="form-group">
                        <label htmlFor="" className="form-lbl">
                          Role<span className="must-field">*</span>
                        </label>
                        <select
                          type="text"
                          value={worker_roles}
                          name="worker_roles"
                          id="worker_roles"
                          onChange={(e) =>{
                            dispatch({type:"input",payload:e.target})
                            }}
                          className={`form-control form-g1`}
                        >
                          <option value="">Choose Worker Role</option>;
                          <option value="Plumber">Plumber</option>;
                          <option value="Electrician">Electrician</option>;
                          <option value="Janitor">Janitor</option>;
                          <option value="Cleaner">Cleaner</option>;
                          <option value="Lawn Mower">Lawn mower</option>;
                          <option value="General">General</option>;
                        </select>
                        {errorMessage?.worker_roles ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.worker_roles}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-xl-12 col-md-12 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Street Address<span className="must-field">*</span>
                      </label>
                      <input
                      onChange={(e) =>{
                        dispatch({type:"input",payload:e.target})
                        }}
                        type="text"
                        value={trimStart(address)}
                        name="address"
                        className={`form-control form-g1`}
                        placeholder={`Address`}
                      />
                      {errorMessage?.address ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.address}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-12 col-md-12 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Apartment, Suite
                      </label>
                      <input
                     onChange={(e) =>{
                      dispatch({type:"input",payload:e.target})
                      }}
                        type="text"
                        value={trimStart(apartment)}
                        name="apartment"
                        className={`form-control form-g1`}
                        placeholder={`Apartment`}
                      />
                      {errorMessage?.apartment ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.apartment}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Country<span className="must-field">*</span>
                      </label>
                      <select
                        value={trimStart(country)}
                        name="country"
                        onChange={(e) =>{
                          dispatch({type:"input",payload:e.target})
                          }}
                        className={`form-control form-g1`}
                        placeholder={`Country`}
                      >
                        <option value="">Choose Country</option>
                        {countryList?.map((items, i) => {
                          return (
                            <option key={i} value={items.id}>
                              {items.country_name}
                            </option>
                          );
                        })}
                      </select>

                      {errorMessage?.country ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.country}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Province<span className="must-field">*</span>
                      </label>
                      <select
                        value={trimStart(province)}
                        name="province"
                        onChange={(e) =>{
                          dispatch({type:"input",payload:e.target})
                          }}
                        className={`form-control form-g1 `}
                        placeholder={`Province`}
                      >
                        <option value="">Choose Province</option>
                        {stateList?.map((items, i) => {
                          return (
                            <option key={i} value={items.id}>
                              {items.province_name}
                            </option>
                          );
                        })}
                      </select>

                      {errorMessage?.province ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.province}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        City<span className="must-field">*</span>
                      </label>
                      <input
                onChange={(e) =>{
                  dispatch({type:"input",payload:e.target})
                  }}
                        type="text"
                        value={trimStart(city)}
                        name="city"
                        className={`form-control form-g1`}
                        placeholder={`City`}
                      />
                      {errorMessage?.city ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.city}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="col-xl-6 col-md-6 mb-2">
                    <div className="form-group">
                      <label htmlFor="" className="form-lbl">
                        Post Code<span className="must-field">*</span>
                      </label>
                      <input
                     onChange={(e) =>{
                      dispatch({type:"input",payload:e.target})
                      }}
                        type="text"
                        value={trimStart(postal_code)}
                        name="postal_code"
                        className={`form-control form-g1`}
                        placeholder={`Postal Code`}
                      />
                      {errorMessage?.postal_code ? (
                        <div
                          className="error error-message"
                          style={{ color: "red" }}
                        >
                          {errorMessage?.postal_code}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {makeUrl.apiUrl == "tenant" && (
                    <>
                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="building_id" className="form-lbl">
                            Building Name <span className="must-field">*</span>
                          </label>
                          <select
                          onChange={(e) =>{
                            dispatch({type:"input",payload:e.target})
                            }}
                            type="text"
                            className="form-control form-g1"
                            id="form-request*"
                            name="building_id"
                            value={building_id}
                          >
                            <option value="">Choose Building</option>
                            {buildinglist?.length >= 0 ? (
                              buildinglist?.map((items, i) => {
                                return (
                                  <option key={i} value={items.id}>
                                    {items.building_name}
                                  </option>
                                );
                              })
                            ) : (
                              <option value="">No building Name</option>
                            )}
                          </select>
                          {errorMessage?.building_id ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.building_id}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="unit_id" className="form-lbl">
                            Unit Name <span className="must-field">*</span>
                          </label>
                          <select
                      
                           
                            className="form-control form-g1"
                            id="form-request*"
                            name="unit_id"
                            value={unit_id}
                            onChange={(e) =>{
                              dispatch({type:"input",payload:e.target})
                              }}
                          >
                            <option value="">Choose unit</option>
                            {unitlist?.length > 0 ? (
                              unitlist?.map((items, i) => {
                                return (
                                  <option key={i} value={items.id}>
                                    {items.unit_name}
                                  </option>
                                );
                              })
                            ) : (
                              <option value="">No Unit Name</option>
                            )}
                          </select>
                          {errorMessage?.unit_id ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.unit_id}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>



                      { unit_id && unitlist?.length!==0 &&
                      <>
                        <div className="col-xl-6 mb-2">
                          <label htmlFor="" className="form-lbl">
                            Type Of Unit<span className="must-field">*</span>
                          </label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control form-g1"
                              id="Description"
                              readOnly
                              placeholder="Apartment Size"
                              name="unit_type"
                              value={unitdetails?.unit_type}
                            />
                          </div>
                        </div>
                        <div className="col-xxl-6 mb-2">
                          <label htmlFor="" className="form-lbl">
                            Apartment Size<span className="must-field">*</span>
                          </label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control form-g1"
                              id="Description"
                              readOnly
                              placeholder="Apartment Size"
                              name="apartment_size"
                              value={unitdetails?.apartment_size}
                             
                            />
                        
                          </div>
                        </div>
                        {unitdetails?.unit_type !== "Commercial" && 
                        
                        <div className="col-xl-12 col-md-12 mb-2">
                          <label htmlFor="" className="form-lbl">
                            Unit Size<span className="must-field">*</span>
                          </label>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control form-g1"
                              id="Description"
                              placeholder="Unit Size"
                              name="apartment_part"
                              readOnly
                              value={unitdetails?.unit_part}
                             
                            />
                        
                          </div>
                        </div>}
                        {unitdetails?.unit_type !== "Residential" &&   Object?.keys(taxInfo)?.length > 0 && (
                        <div className="col-12 mb-2">
                          <div className="row">
                            <>
                              {Object?.keys(taxInfo)?.map((taxx, ind) => (
                                <div className="col ">
                                  <label htmlFor="" className="form-lbl">
                                    {taxx}
                                    (%)
                                  </label>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control form-g1"
                                      id="Description"
                                      placeholder={taxx}
                                      name={taxx}
                                      value={Object?.values(taxInfo)[ind]}
                                      readOnly
                                    />
                                  </div>
                                </div>
                              ))}
                            </>
                          </div>
                        </div>
                      )}

                      </>
                      }

                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="monthly_rent" className="form-lbl">
                            Monthly Rent<span className="must-field">*</span>
                          </label>
                          <input
                            onChange={(e) =>{
                              dispatch({type:"input",payload:e.target})
                              }}
                            type="text"
                            className="form-control form-g1"
                            id="form-request*"
                            name="monthly_rent"
                            value={monthly_rent}
                            
                            placeholder="Monthly Rent"
                          />
                          {errorMessage?.monthly_rent ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.monthly_rent}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label
                            htmlFor="lease_start_date"
                            className="form-lbl"
                          >
                            Lease Start Date
                            <span className="must-field">*</span>
                          </label>
                          

                          <DatePicker
                            selected={lease_start_date}
                            onChange={(date) =>
                            { 
                              dispatch({type:"input", payload: {value:date,name:'lease_start_date',type:""}})
                              }
                            }
                            required
                            className="form-control form-g1"
                          />

                          {errorMessage?.lease_start_date ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.lease_start_date}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="lease_end_date" className="form-lbl">
                            Lease End Date<span className="must-field">*</span>
                          </label>

                          <DatePicker
                            selected={lease_end_date}
                            onChange={(date) =>
                            { 
                              dispatch({type:"input", payload: {value:date,name:'lease_end_date',type:""}})
                            }
                            }
                            required
                            className="form-control form-g1"
                          />

                          {errorMessage?.lease_end_date ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.lease_end_date}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </>
                  )} */}

                  {/* Map inputs  */}


<>
                  {
                    profileInputs?.filter(buildingInput => (buildingInput.isShow)).map(({required,isReadOnly,type,label,placeholder,colSize,name},index) => (
                      <>
                     
                     {
                      type=="selectbox" ?
                      
                      <InputTypeSelect
                      required={required}

                      optionsList={name =="country" ?  countryList : name=="worker_roles" ? typeOfWorkerList  : name=="building_id" ? buildinglist  :name=="unit_id" ? unitlist :  stateList }
                      optionName={name =="country" ? "country_name" : name=="worker_roles" ? "name"  : name=="building_id" ? "building_name" : name=="unit_id" ? "unit_name" : "province_name" }
                        
                        label={label}
                      type={type}
                      name={name}
                      placeholder={placeholder}
                      errorMessage={profileState?.errorMessage?.[name]}
                      dispatch={dispatch}
                      stateData={profileState}
                      colSize={colSize}
                        />
                    
                    :
                    
                    
                    type=="textarea" ?   


                    <InputTypeTextarea
                    label={label}
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    required={required}
                   
                    dispatch={dispatch}
                    stateData={profileState}
                    errorMessage={profileState?.errorMessage?.[name]}
                    colSize={colSize} />
                     :   type=="date" ?   


                     <InputTypeDate
                     label={label}
                     type={type}
                     name={name}
                     placeholder={placeholder}
                     required={required}
                    
                     dispatch={dispatch}
                     stateData={profileState}
                     errorMessage={profileState?.errorMessage?.[name]}
                     colSize={colSize} /> :
                 <InputTypeText
                 required={required}
                 isReadOnly={isReadOnly}
                 label={label}
                 type={type}
                 name={name}
                 placeholder={placeholder}
                 errorMessage={profileState?.errorMessage?.[name]}

                 dispatch={dispatch}
                 stateData={profileState}
                 colSize={colSize}
                 
                 />
                     }
                     
                        
                      </>
                    ))
                  }
                </>
                </div>
              </div>
              <div className="col-xl-4 d-flex justify-content-xl-end">
                <div className="area-hide mt-5 mt-xl-0">
                  {(makeUrl.apiUrl == "tenant" || makeUrl.apiUrl == "worker") && (
                    <div className="">
                      <div className="toggl-switch d-flex align-items-center tgl-desk">
                        <label className="switch">
                     
                          <input
                            onChange={(e) => {
                              !profileId 
                              ?   dispatch({type:"input",payload:e.target})
                                : (profileId && profileState?.pending_tasks > 0)
                                  ? notify(
                                    "You can't change the status because the worker has a task assigned.",
                                    "warning"
                                  )
                                  :  (profileId && profileState?.pending_requests > 0)
                                  ? notify(
                                    "You can't change the status because the Tenant has  task request.",
                                    "warning"
                                  ):  dispatch({type:"input",payload:e.target})

                            }}
                            type="checkbox"
                            className="switch-input"
                            checked={status == true}
                            value={status}
                            name="status"
                          />
                          <span
                            className="switch-label"
                            data-on="Active"
                            data-off="Inactive"
                          ></span>
                          <span className="switch-handle"></span>
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="image-area d-flex align-items-center justify-content-center position-relative">
                    <img
                      src={
                        profile_image?.url?.length > 0
                          ? profile_image?.url
                          : DummyImg
                      }
                      alt=""
                    />
                    <div className="img-upload">
                      <label htmlFor="profile_image" className="img-upload-lbl">
                        <FaPen className="edit-pen" color="black" />
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="profile_image"
                        name="profile_image"
                        accept="image/*"
                        onChange={(e) =>{
                          dispatch({type:"file",payload:e.target})
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* show input fron tenant create  */}

            {makeUrl.apiUrl == "tenant" && (
              <>
                <hr className="w-100" />
                <h1 className="heading-text mb-3 mb-md-5">
                  Advance Information
                </h1>
                <div className="col-xl-10">
                  <div className="row">
                    <div className="col-xl-3 col-md-3 mb-2">
                      <div className="form-group">
                        <label htmlFor="advance_rent" className="form-lbl">
                          Advance Rent
                        </label>
                        <input
                          onChange={(e) =>{
                            dispatch({type:"input",payload:e.target})
                    }}
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="advance_rent"
                          value={trimStart(advance_rent)}
                          placeholder="Advance Rent"
                        />
                        {errorMessage?.advance_rent ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.advance_rent}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-3 mb-2">
                      <div className="form-group">
                        <label htmlFor="key_deposit" className="form-lbl">
                          Key Deposit
                        </label>
                        <input
                       onChange={(e) =>{
                        dispatch({type:"input",payload:e.target})
            }}
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="key_deposit"
                          value={trimStart(key_deposit)}
                          placeholder="Key Deposit"
                        />
                        {errorMessage?.key_deposit ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.key_deposit}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-3 mb-2">
                      <div className="form-group">
                        <label htmlFor="laundry_deposit" className="form-lbl">
                          Laundry Card Deposit
                        </label>
                        <input
                     onChange={(e) =>{
                      dispatch({type:"input",payload:e.target})
                 }}
                          type="text"
                          className="form-control form-g1"
                          id="form-request*"
                          name="laundry_deposit"
                          value={trimStart(laundry_deposit)}
                          placeholder="Laundry Card Deposit"
                        />
                        {errorMessage?.laundry_deposit ? (
                          <div
                            className="error error-message"
                            style={{ color: "red" }}
                          >
                            {errorMessage?.laundry_deposit}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="w-100" />
                <div className="row">
                  <div className="col-xxl-8 col-xl-12">
                    <h1 className="heading-text mb-3 mb-md-5">
                      Additional Information
                    </h1>
                    <div className="row gy-2 gy-lg-4 gx-xl-5 gx-3">
                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="parking" className="form-lbl">
                            Parking & Others
                          </label>
                          <input
                     onChange={(e) =>{
                      dispatch({type:"input",payload:e.target})
         }}
                            type="text"
                            className="form-control form-g1"
                            id="form-request*"
                            name="parking"
                            value={trimStart(parking)}
                            placeholder="Parking & Others"
                          />
                          {errorMessage?.parking ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.parking}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="locker" className="form-lbl">
                            Locker
                          </label>
                          <input
                         onChange={(e) =>{
                          dispatch({type:"input",payload:e.target})
         }}
                            type="text"
                            className="form-control form-g1"
                            id="form-request*"
                            name="locker"
                            value={trimStart(locker)}
                            placeholder="locker"
                          />
                          {errorMessage?.locker ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.locker}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="internet" className="form-lbl">
                            Internet
                          </label>
                          <input
                       onChange={(e) =>{
                        dispatch({type:"input",payload:e.target})
 }}
                            type="text"
                            className="form-control form-g1"
                            id="form-request*"
                            name="internet"
                            value={trimStart(internet)}
                            placeholder="Internet"
                          />
                          {errorMessage?.internet ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.internet}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className="col-xl-6 col-md-6 mb-2">
                        <div className="form-group">
                          <label htmlFor="laundry_deposit" className="form-lbl">
                            NSF
                          </label>
                          <input
                     onChange={(e) =>{
                      dispatch({type:"input",payload:e.target})
             }}
                            type="text"
                            className="form-control form-g1"
                            id="form-request*"
                            name="nsf"
                            value={trimStart(nsf)}
                            placeholder=" NSF"
                          />
                          {errorMessage?.nsf ? (
                            <div
                              className="error error-message"
                              style={{ color: "red" }}
                            >
                              {errorMessage?.nsf}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      {profileId && (
                        <>
                          <hr className="w-100" />
                          <h1 className="heading-text mb-3 mb-md-5">
                            Hydro Inv Information
                          </h1>
                          {hydroInvoices?.map(
                            (setvalue, index) => (
                              <div key={index} className="supplier-details row">
                                <div className="col-6 col-md-4 mb-2 mt-4">
                                  <div className="form-group">
                                    <label htmlFor="" className="form-lbl">
                                      Amount
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control form-g1"
                                      id="form-request*"
                                      name="amount"
                                      value={setvalue.amount}
                                      onChange={(e) =>{
                                        dispatch({
                                          type: "UPDATE_INPUT_hydroInvoice_VALUE",
                                          index,
                                          payload: e.target
                                        })
                                       }}
                                      placeholder=""
                                    />
                                  </div>
                                </div>
                                <div className="col-6 col-md-4 mb-2 mt-4">
                                  <div className="form-group">
                                    <label htmlFor="" className="form-lbl">
                                      Select Month
                                      <span className="must-field">*</span>
                                    </label>
                                    <select
                                      value={setvalue?.month}
                                      name="month"
                                      onChange={(e) => {
                                        dispatch({
                                          type: "UPDATE_INPUT_hydroInvoice_VALUE",
                                          index,
                                          payload: e.target
                                        })
                                        
                                    }}
                                      className={`form-control form-g1`}
                                    >
                                      <option value="">Choose Month</option>
                                      {mS?.map((items, i) => {
                                        return (
                                          <option key={i} value={items}>
                                            {items}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-4 mb-2 mt-4">
                                  <div className="form-group">
                                    <label htmlFor="" className="form-lbl">
                                      Select file
                                    </label>
                                    <div className="d-flex align-items-center">
                                      <input
                                        type="file"
                                        className="form-control form-g1 me-3"
                                        id="form-request*"
                                        name="hydro_img"
                                        // accept="image/*"
                                        // value={setvalue.file}
                                        onChange={(e) =>{ 
                                          
                                          dispatch({
                                            type: "UPDATE_INPUT_hydroInvoice_VALUE",
                                            index,
                                            payload: e.target
                                          })
                                      }}
                                        placeholder=""
                                      />
                                      <FaEye
                                        onClick={(e) =>
                                       
                                          {
                                            hydroInvoices[index].hydro_img.url &&
                                            setModalPreviewData(hydroInvoices[index].hydro_img.url);
                                            handleShow(true)
                                          }

                                        }
                                      />
                                    </div>
                                  </div>
                                </div>

                                {hydroInvoices?.length !== 1 && (
                                  <div className=" col-sm-3 col-xl-2 d-flex align-items-end">
                                    <button
                                      className="px-3 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                                      onClick={(e) =>
                                  {     
                                    dispatch({ type: "REMOVE_hydroInvoice_FIELD", index })
                                  }
                                      }
                                    >
                                      REMOVE
                                    </button>
                                  </div>
                                )}

                                {hydroInvoices?.length - 1 ===
                                  index &&
                                  hydroInvoices?.length <
                                  100 && (
                                    <>
                                      <div className=" col-sm-2 col-lg-1 d-flex align-items-end">
                                        <button
                                          className="px-3 py-2 border fw-bold d-flex align-items-center justify-content-center text-4 from_input rounded-2"
                                          onClick={()=>{
                                            dispatch({ type: "ADD_hydroInvoice_FIELD" });
                                          }}
                                        >
                                          ADD
                                        </button>
                                      </div>
                                    </>
                                  )}
                              </div>
                            )
                          )}
                        </>
                      )}

                      <div className="col-xl-12 form-radion-btn mb-2">
                        <div className="row d-flex align-items-center">
                          <div className="col-auto">
                            <p className="unit-heading2">
                              Unit's Payment Type :
                            </p>
                          </div>

                          <div className="col-xl-9">
                            <div className="form-floating d-flex flex-wrap flex-md-nowrap mt-2 mt-lg-0">
                              {paymentOption?.map((choice, index) => (
                                <div
                                  key={index}
                                  className="form-check d-flex align-items-center ps-0 form-radio-check "
                                >
                                  <label
                                    className="radio-lbl me-3"
                                    htmlFor={`xyz${choice.id}`}
                                  >
                                    <input
                                      type="radio"
                                      className="formradio me-1"
                                      id={`xyz${choice.id}`}
                                      name={"payment_mode"}
                                      value={choice.name}
                                      checked={choice.name==payment_mode}
                                      onChange={(e) => {
                                        dispatch({type: "input",payload: e.target})
                                        }}
                                    />
                                    {choice.name}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      {modalPreviewData !== "" && (
                        <Modal
                          size="lg"
                          aria-labelledby="contained-modal-title-vcenter"
                          centered
                          show={show}
                          onHide={handleClose}
                        >
                          <Modal.Header>
                            <Modal.Title
                              id="contained-modal-title-vcenter"
                              className="w-100"
                            >
                              <div className="modal-top">
                                <div className="d-flex justify-content-between align-items-center">
                                  <h3 className="heading-text">
                                    Payment Receipt{" "}
                                  </h3>
                                </div>
                                <div className="">
                                  <div className="buttons d-flex align-items-center">
                                    <div className="form search-bar1 modal-searchbar w-100"></div>
                                  </div>
                                </div>
                              </div>
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <iframe
                              src={modalPreviewData}
                              width="100%"
                              height="500px"
                            />
                          </Modal.Body>
                        </Modal>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="col-xl-12 col-md-6 mt-4 col-md-6">
              <button
                type="submit"
                className="btn-primary form-btn"
                onClick={(e) => {
                  makeUrl.apiUrl == "manager"
                    ? showModalbuildingList(e)
                    : Submitpartner(e);
                }}
              >
                Submit
              </button>
            </div>
          </form>
          {errorMessage?.err ? (
            <div className="col-xl-12 mt-2 ">
              <b className=" text-m bg-red-50 block text-center p-4 rounded border border-danger text-danger">
                {errorMessage?.err}
              </b>
            </div>
          ) : null}


        </div>

        {makeUrl.apiUrl == "manager" && <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter" className="w-100">
              <div className="modal-top">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="heading-text">Select Building </h3>
                </div>
                <div className="">
                  <div className="buttons d-flex align-items-center">
                    <div className="form search-bar1 modal-searchbar w-100">
                      <input
                        type="search"
                        className="form-control search-new"
                        placeholder="Search Building"
                        aria-label="search"
                        aria-describedby="search"
                        name="searchKeywords"
                        value={trimStart(searchKeywords)}
                        onChange={(e) =>{
                          dispatch({type:"input", payload: e.target})
                       }}
                      />
                      <button
                        className="search-btn"
                        onClick={(e) => searchBuilding(e)}
                        type="submit"
                      >
                        <FaSearch className="m-0" color="#bebebe" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ul className="modal-list">
              {buildinglist?.length > 0 ? (
                <>
                  {buildinglist?.map((items, i) => {
                    return (
                      <li
                        className="d-flex justify-content-between align-items-center"
                        key={i}
                      >
                        <div>
                          <p>{items.building_name}</p>
                        </div>

                        <div className="check-btn">
                          <input
                            type="checkbox"
                            name="managerBuildingAssigns"
                            id={`build${items.id}`}
                            style={{ display: "none" }}
                            value={items.id}
                            checked={managerBuildingAssigns?.includes(
                              items.id
                            )}
                            onChange={(e) => {
                              dispatch({type:"managerBuildingAssigns", payload: e.target,itemId:items.id})
                             }}
                          />
                          <label
                            className="modal-choose"
                            htmlFor={`build${items.id}`}
                          >
                            Choose
                          </label>
                        </div>
                      </li>
                    );
                  })}
                </>
              ) : (
                <div className="align-items-center empty-list">
                  <h1>No Data Found</h1>
                </div>
              )}
            </ul>
            {errorMessage && (
              <div
                className="error error-message text-center"
                style={{ color: "red" }}
              >
                {errorMessage?.error}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center justify-content-lg-end align-items-center modalbtn-area">
              <button
                className="skip-btn text-center me-3 skip-btn-modal"
                onClick={(e) => {
                
                  dispatch({type:"set_error",payload:{}})


                  Submitpartner(e, "skipnow");
                 
                }}
              >
                Skip now
              </button>
              <button
                className="continue-btn"
                onClick={(e) => {
                  Submitpartner(e);
                
                }}
              >
                {!profileId ? "Submit" : "Update"}
              </button>
            </div>
          </Modal.Footer>
        </Modal>}
      </DashboardLayouts>
    </>
  );
}
export default AddProfileGobal;
